import albumTypeApi from "../apis/albumTypeApi";
import { apiCallBegin, apiCallSuccess, apiCallError } from "./loading";

export const ACTION_TYPES = {
    CREATE_ALBUM_TYPE: 'CREATE_ALBUM_TYPE',
    UPDATE_ALBUM_TYPE: 'UPDATE_ALBUM_TYPE',
    DELETE_ALBUM_TYPE: 'DELETE_ALBUM_TYPE',
    FETCH_ALL_ALBUM_TYPES: 'FETCH_ALL_ALBUM_TYPES'
}

export const fetchAll = () => dispatch => {
    dispatch(apiCallBegin());
    albumTypeApi.albumType().fetchAll()
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_ALL_ALBUM_TYPES,
                payload: response.data
            });
            dispatch(apiCallSuccess());
            return Promise.resolve(response);
        })
        .catch(err => {
            dispatch(apiCallError());
            return Promise.reject(err);
        })
}
